import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { EndpointService } from "@app/core";
import { Rol, TablaMaestra } from "@app/shared";
import { AdministrationComponent } from "@app/administration/administration.component";

export interface MasterGroupPermission {
  id: number;
  id_maestra: number;
  ver: boolean;
  crear: boolean;
  modificar: boolean;
  eliminar: boolean;
  nombre_maestra: string;
}

@Injectable()
export class ManagementMasterTableDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   *Consulta los roles del sistema(grupos).
   *
   * @return {*}  {Observable<Rol[]>}
   * @memberof ManagementMasterTableDataService
   */
  getRoles(): Observable<Rol[]> {
    return this.http.get<Rol[]>(this.api.get("roles"));
  }

  /**
   *Consulta los permisos de los roles del sistema(grupos).
   *
   * @param {number} idGroup
   * @return {*}  {Observable<RolPermisos>}
   * @memberof ManagementMasterTableDataService
   */
  getRolesPermission(idGroup: number): Observable<MasterGroupPermission[]> {
    //"https://6d796566-01de-4c35-9fcc-cf67e4a4c068.mock.pstmn.io/roles-mastertables/",[idGroup]
    // Cambio, no se hace consulta al dummint, va a la api al endpoint adminRolesMaester.
    return this.http.get<MasterGroupPermission[]>(this.api.get('adminRolesMaester', [idGroup]))
  }

  /**
   *Consulta la lista de tablas maestras del sistema
   *
   * @return {*}  {Promise<TablaMaestra[]>}
   * @memberof ManagementMasterTableDataService
   */
  getMasterTables(): Promise<TablaMaestra[]> {
    return new Promise((resolve, reject) => {
      this.http.get<TablaMaestra[]>(this.api.get("masterTable")).subscribe(
        (specificValues) => {
          resolve(specificValues);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  
   /**
    *Agregar maestra a un grupo
    *
    * @param {RolDefaultPermissions} permission
    * @return {*}  {Promise<boolean>}
    * @memberof ManagementMasterTableDataService
    */
   addMasterTable(masterTable: any): Promise<boolean> {
     return new Promise((resolve, reject) => {
      //this.http.skipErrorHandler().post<boolean>("https://6d796566-01de-4c35-9fcc-cf67e4a4c068.mock.pstmn.io/add-roles-mastertables/", masterTable).subscribe(
      // Se cambia el dummint por la api apuntando al endpoint adminRolesMaester      
      this.http.skipErrorHandler().post<boolean>(this.api.get('adminRolesMaester'), masterTable).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Maestra agregada al grupo');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error['permiso']) {
              this.toastr.error('Fallo del sistema', 'Error de operacion')
            } else {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
          }
          reject(err);
        }
      );
    });
  }

  /**
   *Actualiza una maestra del grupo
   *
   * @param {*} masterTable
   * @return {*}  {Promise<boolean>}
   * @memberof ManagementMasterTableDataService
   */
  updateMasterTable(id_master_table: number, masterTable: any = {}): Promise<boolean> {
    return new Promise((resolve, reject) => {
      //this.http.skipErrorHandler().put<boolean>("https://6d796566-01de-4c35-9fcc-cf67e4a4c068.mock.pstmn.io/roles-mastertables/", [id_master_table], masterTable).subscribe(
      // Se cambia el dummint por la api apuntando al endpoint adminRolesMaester      
      this.http.put<boolean>(this.api.get('adminRolesMaester', [id_master_table]), masterTable).subscribe(
        resp => {
          
          this.toastr.success('Operación exitosa', 'Maestra del grupo actualizada');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error['permiso']) {
              this.toastr.error('Fallo del sistema', 'Error de operacion')
            } else {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
          }
          reject(err);
        }
      );
    });
  }

  /**
   *Elimina una maestra del grupo
   *
   * @param {number} id_master_table
   * @return {*}  {Promise<boolean>}
   * @memberof ManagementMasterTableDataService
   */
  deleteMasterTable(id_master_table: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      //this.http.skipErrorHandler().delete<boolean>("https://6d796566-01de-4c35-9fcc-cf67e4a4c068.mock.pstmn.io/roles-mastertables/1/").subscribe(
      // Se cambia el dummint por la api apuntando al endpoint adminRolesMaester
      this.http.delete<boolean>(this.api.get('adminRolesMaester', [id_master_table])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Maestra eliminada del grupo');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error['permiso']) {
              this.toastr.error('Fallo del sistema', 'Error de operacion')
            } else {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-mastertable-permission/shared/management-mastertable.data.service.ts